import React from 'react';

interface ModelCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

export default function ModelCard({ title, description, icon, onClick, disabled }: ModelCardProps) {
  return (
    <div className={`bg-white p-6 rounded-lg shadow-sm ${disabled ? 'opacity-50' : ''}`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium text-gray-900">{title}</h3>
        {icon}
      </div>
      <p className="text-sm text-gray-600 mb-4">{description}</p>
      <button
        onClick={onClick}
        disabled={disabled}
        className="w-full px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
      >
        {disabled ? 'Select a Deal' : 'Start Analysis'}
      </button>
    </div>
  );
}